import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import type { LeadRecord } from '@flashpoint/site-dna';
import { onLeadSnapshot } from '../lib/firestore';
import { PrintableOptionSet } from '../wizard/PrintableOptionSet';

/**
 * Standalone printable view of a lead's option set. Lives OUTSIDE the
 * AppShell so the chrome doesn't show up in print or PDF exports.
 *
 * Opened in a new tab from the wizard's Review step via the
 * "Print option set" button.
 */
export function PrintOptionsPage() {
  const { id } = useParams<{ id: string }>();
  const [lead, setLead] = useState<LeadRecord | null | undefined>(undefined);

  useEffect(() => {
    if (!id) return;
    return onLeadSnapshot(id, setLead);
  }, [id]);

  if (lead === undefined) {
    return <div style={{ padding: 40, fontFamily: 'system-ui' }}>Loading...</div>;
  }
  if (lead === null) {
    return <div style={{ padding: 40, fontFamily: 'system-ui' }}>Lead not found.</div>;
  }
  return <PrintableOptionSet lead={lead} />;
}
